import { io } from "socket.io-client";

const deviceId = localStorage.getItem("deviceId") || crypto.randomUUID();
localStorage.setItem("deviceId", deviceId);

// ✅ Check karo login data at import time
const token = localStorage.getItem("token");
const userData = JSON.parse(localStorage.getItem("user") || "null");
const userId = userData?._id;

const presenceSocket = io(process.env.VUE_APP_BASE_URL, {
  auth: { token, userId, deviceId },
  withCredentials: true,
  autoConnect: !!userId, // ✅ userId hai to auto connect, nahi hai to nahi
});

presenceSocket.on("connect", () => {
  console.log("🟢 Presence Connected:", presenceSocket.id);
  console.log("🔍 Presence UserId:", presenceSocket.auth.userId);
});

presenceSocket.on("connect_error", (err) => {
  console.log("🔴 Presence Error:", err.message);
});

// 💓 HEARTBEAT
setInterval(() => {
  if (presenceSocket.connected) {
    presenceSocket.emit("user:ping", {
      userId: presenceSocket.auth.userId,
      deviceId,
      time: Date.now(),
    });
  }
}, 15000);

export function connectPresence() {
  const token = localStorage.getItem("token");
  const userData = JSON.parse(localStorage.getItem("user") || "null");
  const userId = userData?._id;

  console.log("🔍 Connecting Presence UserId:", userId);

  presenceSocket.auth = { token, userId, deviceId };

  if (!presenceSocket.connected) {
    presenceSocket.connect();
  }
}

export default presenceSocket;